import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";

type ScreenType = "evidence-register" | "nsu-register" | "redirect";

interface ConciliationErrorFallbackProps {
  error?: unknown;
  onRetry: () => void;
  screen: ScreenType;
}

const screenMessages: Record<ScreenType, { title: string; description: string }> = {
  "evidence-register": {
    title: "Erro ao carregar Registro de Evidências",
    description:
      "Não foi possível carregar a tela de registro de evidências. Por favor, tente novamente ou solicite um novo link por e-mail.",
  },
  "nsu-register": {
    title: "Erro ao carregar Registro de NSU",
    description:
      "Não foi possível carregar a tela de registro de NSU. Por favor, tente novamente ou solicite um novo link por e-mail.",
  },
  redirect: {
    title: "Erro ao processar redirecionamento",
    description:
      "Não foi possível validar seu acesso. Por favor, solicite um novo link por e-mail.",
  },
};

export function ConciliationErrorFallback({
  onRetry,
  screen,
}: ConciliationErrorFallbackProps) {
  const message = screenMessages[screen] ?? {
    title: "Erro inesperado",
    description: "Ocorreu um erro. Por favor, tente novamente.",
  };

  const handleRetry = () => {
    onRetry();
  };

  const handleRequestNewLink = () => {
    window.location.href = "/informations?error=true";
  };

  return (
    <div className="min-h-screen w-screen overflow-hidden flex items-center justify-center bg-gray-100 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
            <AlertCircle className="w-8 h-8 text-red-600" />
          </div>
          <CardTitle className="text-xl font-bold text-gray-900">
            {message.title}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-gray-600 text-sm">
            {message.description}
          </p>

          <div className="flex flex-col gap-2">
            <Button
              variant="default"
              onClick={handleRetry}
              className="w-full flex items-center justify-center gap-2"
            >
              <RefreshCw className="w-4 h-4" />
              Tentar novamente
            </Button>

            <Button
              variant="outline"
              onClick={handleRequestNewLink}
              className="w-full"
            >
              Solicitar novo link
            </Button>
          </div>

          <p className="text-center text-xs text-gray-400 mt-4">
            Se o problema persistir, entre em contato com o suporte.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

export default ConciliationErrorFallback;
